export default "__VITE_ASSET__DyOwrYgl__"